import { Component, OnInit } from '@angular/core';
import { AppState } from 'src/app/app.reducer';
import { Store } from '@ngrx/store';
import { GetDocumentById, ApproveTags, RejectTags } from '../_store/resources.actions';
import { Router, ActivatedRoute } from '@angular/router';
import { map, last, withLatestFrom } from 'rxjs/operators';
import { MatSlideToggleChange, MatTableDataSource } from '@angular/material';
import { Location } from "@angular/common";



@Component({
  selector: 'tags-approval-list',
  templateUrl: './tags-approval-list.component.html',
  styleUrls: ['./tags-approval-list.component.scss']
})
export class TagsApprovalComponent implements OnInit {
  displayedColumns: string[] = ['Tag Name', 'Suggested By', 'Actions'];
  suggestedTags$: any = [];
  docID: string = ''
  // page = 1;
  // totalPages: number;
  dataSource: MatTableDataSource<any>;
  payload: object = { tagIdToAdd: '', tagIdToRemove: '', userId: '' }
  removeFlag: boolean

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public location: Location
  ) {
    this.activatedRoute.params.subscribe((params: any) => {
      this.docID = (params || {}).id;
    });
  }

  ngOnInit() {

    this.store.dispatch(new GetDocumentById(this.docID))
    this.store.select(store => store.resources.docDetail).subscribe(res => {
      this.suggestedTags$ = []
      if (location.href.split('/').splice(-1, 1)[0] == 'remove') {
        this.removeFlag = true

        if (res['suggestTagsToRemove']) {
          res['suggestTagsToRemove'].map(data => data.tags.map(tag => {
            let temp = {}
            temp['tag'] = tag.tag
            temp['tagId'] = tag._id
            temp['user'] = data.user
            this.suggestedTags$.push(temp)
          }))
        }
      }
      else {
        this.removeFlag = false

        if (res['suggestTagsToAdd']) {
          res['suggestTagsToAdd'].map(data => data.tags.map(tag => {
            let temp = {}
            temp['tag'] = tag.tag
            temp['tagId'] = tag._id
            temp['user'] = data.user
            this.suggestedTags$.push(temp)
          }))
        }
      }

      this.dataSource = new MatTableDataSource(this.suggestedTags$);
    })


  }

  approveTag(tag, user) {
    this.payload = { tagIdToAdd: tag, userId: user }
    this.store.dispatch(new ApproveTags(this.docID, this.payload))
  }

  rejectTag(tag, user) {
    this.payload = { tagIdToAdd: tag, userId: user }
    this.store.dispatch(new RejectTags(this.docID, this.payload))
  }

  approveRemovalTag(tag, user) {
    this.payload = { tagIdToRemove: tag, userId: user }
    this.store.dispatch(new ApproveTags(this.docID, this.payload))
  }

  rejectRemovalTag(tag, user) {
    this.payload = { tagIdToRemove: tag, userId: user }
    this.store.dispatch(new RejectTags(this.docID, this.payload))
  }


  cancel() {
    this.location.back();
  }

}
